
















































import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { LineLayer } from "@/model/document2/page/surface/design/layer/lineLayer";
import { CurveLayer } from "@/model/document2/page/surface/design/layer/curveLayer";

import { ColorConstruct } from "@/utilityModels/colorConstruct";

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class LineStrokeColorController extends Vue 
{
    @Prop() layer! : LineLayer | CurveLayer;

    private changeColor(hex : string)
    {
        var color = ColorConstruct.createFromHex(hex);
        this.changeLayerProperty("strokeColor", color, true, true);
    }

    private requestColor()
    {
        this.$emit("requestColor", "strokeColor", this.layer.strokeColor);
    }
    
    private changeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeLayerProperty", propertyName, value, isFinish, isOnce);
    }
}
